import { assign } from 'lodash-es'
export default {
  props: {
    column: {
      type: Object, // 当前列
      default: () => ({})
    },
    columnIndex: {
      type: Number, // 当前index
      default: () => null
    },
    prefix: {
      type: String,
      default: () => null
    },
    height: {
      type: Number,
      default: () => null
    },
    tableHeadStyle: { // tableHead 的宽高
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => (null)
    },
    rowIndex: {
      type: Number, // 当前index
      default: () => null
    },
    group: { // tableHead 的宽高
      type: Object,
      default: () => ({})
    },
    groupIndex: {
      type: Number, // 当前index
      default: () => null
    }
  },
  inject: ['table'],
  data () {
    return {
      fixedRight: null,
      fixedLeft: null,
      style: {
        // 'position': 'absolute',
        'margin-right': 0,
        'margin-left': 0
      },
      cloneDom: null
    }
  },
  mounted () {
    // 更新行高
    this.updateHeight()
  },
  computed: {

  },
  watch: {
    'tableHeadStyle': {
      deep: true,
      immediate: true,
      handler (val, oldval) {
        this.updateHeight()
      }
    }
  },
  methods: {
    // 更新行高
    updateHeight () {
      if (this.$el) {
        // console.log('');
        this.$el.style.height = (this.tableHeadStyle.height || this.row?._style?.height) + 'px'
      }
    },
    // 渲染表头
    renderCell (h) {
      let { column, columnIndex, prefix, row, rowIndex, group, groupIndex } = this
      const { title, customRender, key, width, align = 'left', dataIndex, className } = column
      // const { groupScroll } = this.table
      const position = {
        position: column.style?.position,
        [column.style?.positionType]: column.style?.distance + 'px'
      }
      let style = assign(
        this.style,
        {
          width: width ? width + 'px' : '96px',
          height: this.height + 'px'
        },
        position
      )
      if (column.type === 'selection') {
        style['max-width'] = `${width}px`
      }
      let _className = className ? `${prefix}-column-title ${className}` : `${prefix}-column-title`
      return <div
        key={key}
        class={`is-${align} ${prefix}-column-${columnIndex} ${prefix}-column ${`${prefix}-column-${column.class || 'left'}`}`}
        style={style}>
        <div class={_className}>
          
          {
            (column.type === 'selection' && row )? null :
            row ? customRender({
              row,
              group,
              column: {
                dataIndex,
                key
              },
              $index: rowIndex,
              groupIndex
            }) : (typeof title === 'function' ? title({ column, columnIndex }) : title)
          }
        </div>
      </div>
    }
  },
  render (h) {
    return this.renderCell(h)
  }
}
